import React, {useEffect} from "react";

import {useGlobalDataContext} from "../../../GlobalDataContext";
import {getBetTypeName, getBetValueOfType} from "../../utils/helpers";

const SetBetsFromBackend = () => {
    const { state, dispatch } = useGlobalDataContext();

    useEffect(() => {
        formattingBets(state.betsFromBackend)
        return () => {}
    }, [state.betsFromBackend]);

    const formattingBets = (data) => {
        if(!data.Tips) return;
        const roundNumber = state.Round;
        const result = {
            [roundNumber]: data.Tips.map(el => {
                return { [getBetTypeName(el.BetType)]:
                    {
                    tip: getBetTypeName(el.BetType),
                    result: getBetValueOfType(el.BetType, el.Values),
                    resultForRequest: el.Values,
                    stake: el.Stake,
                    betType: el.BetType,
                    }
                }
            })
        }

        dispatch({
            type: "ADD_BET_IN_BETSLIP",
            payload: result
        });
    }

    return ""
}

export default React.memo(SetBetsFromBackend);